import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { CountTotalWorksRequest, StatsApi } from '../../../api/core';
import { getAuthMiddleware } from '../../../Auth/utils/GetAuthMiddleware';
import { AuthContext } from '../../../Auth/components/AuthProvider';
import { Card } from 'primereact/card';
import { FormattedMessage } from 'react-intl';
import { StateContext, StateContextType } from '../../../util/providers/StateProvider';
import { Link } from 'react-router';
import { ProgressSpinner } from 'primereact/progressspinner';
import { StatisticsData } from '../types';
import { mandantSettings } from '../../../Settings/mandants/mandant-settings';

export function Statistics(): ReactNode {
  const stateContext: StateContextType = useContext(StateContext);
  const statisticsData: StatisticsData[] = stateContext.statisticsData;

  return (<div className={'flex justify-content-center'}>
      {(statisticsData.length > 0) &&
        <Card className={`m-5 homepage-statistics count-${statisticsData.length}`}
              pt={{root: {className: 'surface-100'}}}>
          <div className={'grid'}>
            <div className={'title col-12 flex justify-content-center flex-wrap'}>
              <h2 className={'my-2 text-xl sm:text-2xl md:text-4xl'}>
                <FormattedMessage id="statistics.header"/>
              </h2>
            </div>
            {statisticsData.map((data: StatisticsData, i: number): ReactNode => {
              const classNames: string[] = ['entry', 'col-12'];
              if (statisticsData.length % 2 === 0) classNames.push('md:col-6');
              if (statisticsData.length % 3 === 0) classNames.push('lg:col-4');
              if (statisticsData.length % 4 === 0) classNames.push('xl:col-3');
              return <div className={classNames.join(' ')} key={i}>
                <Statistic {...data} />
              </div>;
            })}
          </div>
        </Card>}</div>
  );
}

export function Statistic(data: StatisticsData): ReactNode {
  const {actions} = useContext(AuthContext);
  const statsApi: StatsApi = new StatsApi().withMiddleware(getAuthMiddleware(actions));

  const [value, setValue] = useState<number>(null);

  const topOrga: string = mandantSettings.find((ms) => ms.mandant === data.mandant).topOrga;

  useEffect((): void => {
      const params: CountTotalWorksRequest = {topOrga: `"${topOrga}"`};
      if(data.type !== 'total') params.externalIdentifier = data.type;
      void statsApi.countTotalWorks(params).then((result: number): void => setValue(result));
  }, [data.type, statsApi, topOrga]);

  const thousandSeparator = (number: number): string => {
    return new Intl.NumberFormat().format(number).replace(',', '.');
  };

  return <Card className={'flex flex-column justify-content-center'}
               pt={{root: {className: 'border-bottom-3'}}}>
    <div className={'flex w-12 justify-content-center'}>
      {value === null && <ProgressSpinner style={{width: '3rem', height: '3rem'}} />}
      {value !== null && <h1 className={'mt-0 mb-2'}>{thousandSeparator(value)}</h1>}
    </div>
    <div className={'flex w-12 justify-content-center'}>
      <Link to={data.link}><FormattedMessage id={data.label}/></Link>
    </div>
  </Card>;

}
